import { AfterViewInit, Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output, ViewChild } from '@angular/core';
import { NavigationItem } from '../navigation';
import { NextConfig } from '../../../../../app-config';
import { Location } from '@angular/common';
import { UserService } from 'src/app/trackpayout/administrator/user/user.service';
import { TaskService } from 'src/app/trackpayout/task/task.service';

@Component({
  selector: 'app-nav-content',
  templateUrl: './nav-content.component.html',
  styleUrls: ['./nav-content.component.scss']
})
export class NavContentComponent implements OnInit, AfterViewInit {
  public flatConfig: any;
  public navigation: any;
  public prevDisabled: string;
  public nextDisabled: string;
  public contentWidth: number;
  public wrapperWidth: any;
  public scrollWidth: any;
  public windowWidth: number;
  public isNavProfile: boolean;

  @Output() onNavMobCollapse = new EventEmitter();


  @ViewChild('navbarContent') navbarContent: ElementRef;
  @ViewChild('navbarWrapper') navbarWrapper: ElementRef;

  constructor(public nav: NavigationItem,
    private zone: NgZone,
    private location: Location,
    private userService: UserService,
    private taskservice: TaskService) {

    this.flatConfig = NextConfig.config;
    this.windowWidth = window.innerWidth;

    this.navigation = [];
    this.prevDisabled = 'disabled';
    this.nextDisabled = '';
    this.scrollWidth = 0;
    this.contentWidth = 0;

    this.isNavProfile = false;
  }

  ngOnInit() {
    // Show sidebar immediately with cached or default menu so it doesn't wait for API
    this.applyNavigationFromCache();
    this.userService.getProfile().subscribe(result => {
      if (result['status'] == 200 && result['user']) {
        const user = result['user'];
        const isAdmin = user['is_admin'] == 1;
        const companyId = user['company_id'];
        const integrationType = user['subscription_detail'] && user['subscription_detail']['company_integration_type'];
        this.setNavigationFromProfile(isAdmin, companyId, integrationType);
        this.cacheNavigationForNextLoad(isAdmin, companyId, integrationType);
      }
    }, () => {
      // Keep default/cached nav on error
    });

    if (this.windowWidth < 992) {
      this.flatConfig['layout'] = 'vertical';
      setTimeout(() => {
        document.querySelector('.pcoded-navbar').classList.add('menupos-static');
        (document.querySelector('#nav-ps-flat-able') as HTMLElement).style.maxHeight = '100%';
      }, 500);
    }
  }

  ngAfterViewInit() {
    if (this.flatConfig['layout'] === 'horizontal') {
      this.contentWidth = this.navbarContent.nativeElement.clientWidth;
      this.wrapperWidth = this.navbarWrapper.nativeElement.clientWidth;
    }
  }

  scrollPlus() {
    this.scrollWidth = this.scrollWidth + (this.wrapperWidth - 80);
    if (this.scrollWidth > (this.contentWidth - this.wrapperWidth)) {
      this.scrollWidth = this.contentWidth - this.wrapperWidth + 80;
      this.nextDisabled = 'disabled';
    }
    this.prevDisabled = '';
    if (this.flatConfig.rtlLayout) {
      (document.querySelector('#side-nav-horizontal') as HTMLElement).style.marginRight = '-' + this.scrollWidth + 'px';
    } else {
      (document.querySelector('#side-nav-horizontal') as HTMLElement).style.marginLeft = '-' + this.scrollWidth + 'px';
    }
  }

  scrollMinus() {
    this.scrollWidth = this.scrollWidth - this.wrapperWidth;
    if (this.scrollWidth < 0) {
      this.scrollWidth = 0;
      this.prevDisabled = 'disabled';
    }
    this.nextDisabled = '';
    if (this.flatConfig.rtlLayout) {
      (document.querySelector('#side-nav-horizontal') as HTMLElement).style.marginRight = '-' + this.scrollWidth + 'px';
    } else {
      (document.querySelector('#side-nav-horizontal') as HTMLElement).style.marginLeft = '-' + this.scrollWidth + 'px';
    }

  }

  fireLeave() {
    const sections = document.querySelectorAll('.pcoded-hasmenu');
    for (let i = 0; i < sections.length; i++) {
      sections[i].classList.remove('active');
      sections[i].classList.remove('pcoded-trigger');
    }

    let current_url = this.location.path();
    if (this.location['_baseHref']) {
      current_url = this.location['_baseHref'] + this.location.path();
    }
    const link = "a.nav-link[ href='" + current_url + "' ]";
    const ele = document.querySelector(link);
    if (ele !== null && ele !== undefined) {
      const parent = ele.parentElement;
      const up_parent = parent.parentElement.parentElement;
      const last_parent = up_parent.parentElement;
      if (parent.classList.contains('pcoded-hasmenu')) {
        parent.classList.add('active');
      } else if (up_parent.classList.contains('pcoded-hasmenu')) {
        up_parent.classList.add('active');
      } else if (last_parent.classList.contains('pcoded-hasmenu')) {
        last_parent.classList.add('active');
      }
    }
  }

  navMob() {
    if (this.windowWidth < 992 && document.querySelector('app-navigation.pcoded-navbar').classList.contains('mob-open')) {
      this.onNavMobCollapse.emit();
    }
  }

  fireOutClick() {
    let current_url = this.location.path();
    if (this.location['_baseHref']) {
      current_url = this.location['_baseHref'] + this.location.path();
    }
    const link = "a.nav-link[ href='" + current_url + "' ]";
    const ele = document.querySelector(link);
    if (ele !== null && ele !== undefined) {
      const parent = ele.parentElement;
      const up_parent = parent.parentElement.parentElement;
      const last_parent = up_parent.parentElement;
      if (parent.classList.contains('pcoded-hasmenu')) {
        if (this.flatConfig['layout'] === 'vertical') {
          parent.classList.add('pcoded-trigger');
        }
        parent.classList.add('active');
      } else if (up_parent.classList.contains('pcoded-hasmenu')) {
        if (this.flatConfig['layout'] === 'vertical') {
          up_parent.classList.add('pcoded-trigger');
        }
        up_parent.classList.add('active');
      } else if (last_parent.classList.contains('pcoded-hasmenu')) {
        if (this.flatConfig['layout'] === 'vertical') {
          last_parent.classList.add('pcoded-trigger');
        }
        last_parent.classList.add('active');
      }
    }
  }

  private static readonly NAV_CACHE_KEY = 'tp_nav_cache';

  private applyNavigationFromCache(): void {
    try {
      const cached = sessionStorage.getItem(NavContentComponent.NAV_CACHE_KEY);
      if (cached) {
        const { isAdmin, companyId, integrationType } = JSON.parse(cached);
        this.setNavigationFromProfile(!!isAdmin, companyId, integrationType);
        return;
      }
    } catch (_) { }
    this.navigation = this.nav.getAdminTally();
  }

  private setNavigationFromProfile(isAdmin: boolean, companyId: number, integrationType: number): void {
    if (isAdmin && companyId === 10031 && (integrationType === 2 || integrationType === 3)) {
      this.navigation = this.nav.getConstisoftAdminTally();
    } else if (isAdmin && integrationType === 1) {
      this.navigation = this.nav.getAdmin();
    } else if (!isAdmin && integrationType === 1) {
      this.navigation = this.nav.getNonAdmin();
    } else if (isAdmin && (integrationType === 2 || integrationType === 3)) {
      this.navigation = this.nav.getAdminTally();
    } else if (!isAdmin && (integrationType === 2 || integrationType === 3)) {
      this.navigation = this.nav.getNonAdminTally();
    } else {
      this.navigation = this.nav.getAdminTally();
    }
  }

  private cacheNavigationForNextLoad(isAdmin: boolean, companyId: number, integrationType: number): void {
    try {
      sessionStorage.setItem(NavContentComponent.NAV_CACHE_KEY,
        JSON.stringify({ isAdmin, companyId, integrationType }));
    } catch (_) { }
  }

  getActiveTask() {
    this.taskservice.getActiveTask().subscribe(result => {
      if (result['status'] == "200") {
        this.navigation = this.nav.task = "12";
      }
    });
  }
}
